import styled from 'styled-components'

export const CancelButtonWarningText = styled.div`
  button {
    text-align: left;
  }
`
